import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import * as clientSelector from '../../ngrx/reducers/client.reducer';
import * as fromAuth from '../../ngrx/reducers/auth.reducer';
import { Subscription } from 'rxjs/Subscription';
import { EventData } from '../../providers/event';
import { MessageData } from '../../providers/messages';
import { IUser } from '../../models/user.model';
import { NavController, ActionSheetController, ToastController, Slides } from 'ionic-angular';
import { TrackingData } from '../../providers/tracking';
import { UtilitiesProvider } from '../../providers/utilities';
import { PollPage } from '../../pages/poll/poll';
import { has } from 'lodash';
import { PollEventPage } from '../../pages/poll-event/poll-event';
import { ENV } from '@app/env';
import { GamificationProvider } from '../../providers/gamification';
import { PaymentProvider } from '../../providers/payment';
import { VotingPage } from '../../pages/voting/voting';
import { TranslateCodePipe } from '../../pipes/translate';
import { Translate2Pipe } from '../../pipes/translate2';


@Component({
  selector: 'interactivity-options',
  templateUrl: 'interactivity-options.html'
})
export class InteractivityOptionsComponent implements OnInit, OnDestroy {

  @Input() pageContent: string;
  @Input() clientId: string;
  @Input() configColor: any;
  @Input() eventId: string = '--';
  @Input() noCatalog: boolean = false;
  @Input() noNetworking: boolean = false;
  @Input() noQuestions: boolean = false;
  @Input() noCart: boolean = false;
  @Input() textShare: string;
  @Input() titleShare: string;
  @Input() showShareOption: boolean;
  @Input() textDetailModule: string | { en: string, es: string };

  @ViewChild(PollPage) public pollPage: PollPage;
  @ViewChild(PollEventPage) public eventPollPage: PollEventPage;
  @ViewChild(VotingPage) public eventVotingPage: VotingPage;
  @ViewChild(Slides) slides: Slides;

  public modules: any = null;
  private clientSubscribe: Subscription;
  private userSubscribe: Subscription;
  private eventSubscribe: Subscription;
  public user$: Observable<IUser>;
  public user: any;
  public footerView: boolean = false;
  public shoppingCart$: Observable<any>;
  public footerMessages$: Observable<any[]>;
  public catalogBadge: any[] = null;
  public notificationsBadge: any[] = null;
  public userPatnerId: string;

  constructor(
    private store: Store<{}>,
    private eventData: EventData,
    private msgData: MessageData,
    private paymentData: PaymentProvider,
    private navCtrl: NavController,
    private tracking: TrackingData,
    private utilities: UtilitiesProvider,
    private gamification: GamificationProvider,
    private actionCtrl: ActionSheetController,
    private actionSheetCtrl: ActionSheetController,
    private translatePipe: TranslateCodePipe,
    private toastCtrl: ToastController,
    private translate2: Translate2Pipe
  ) { }

  async ngOnInit() {
    this.user$ = this.store.select(fromAuth.getUser);
    if (this.textDetailModule) {
      if (typeof this.textDetailModule === "string") {
        this.textDetailModule = await this.translatePipe.transform(this.textDetailModule)
      } else {
        this.textDetailModule = this.translate2.transform(this.textDetailModule)
      }
    }
    if (this.titleShare) this.titleShare = await this.translatePipe.transform(this.titleShare)
    if (this.textShare) this.textShare = await this.translatePipe.transform(this.textShare)
    if (this.utilities.validateEventIdParam(this.eventId)) {
      this.eventSubscribe = this.eventData.getEventConfig(this.clientId, this.eventId)
        .subscribe(config => {
          if (config) this.modules = config.modules;
        });
    } else {
      this.clientSubscribe = this.store.select(clientSelector.getClientModules)
        .subscribe(modules => this.modules = modules)
    }

    this.userSubscribe = this.user$.subscribe(user => {
      if (user) {
        this.user = user;
        this.userPatnerId = user.info.partnerId;
      }
    });

    if (!this.noCatalog) {
      this.findCatalog();
    }

    if (!this.noCart) {
      this.findCart();
    }

    this.findFooterMsg()
  }

  findCatalog() {
    if (this.user) {
      this.tracking.findCatalogByUser(this.clientId, this.user.info.id).subscribe((result: any) => {
        this.catalogBadge = result.data;
      });
    }
  }

  public validateShareComponent() {
    if (!this.showShareOption) {
      return false;
    } else {
      return this.modules.share_pages;
    }
  }

  findFooterMsg() {
    if (this.user) {
      if (this.utilities.validateEventIdParam(this.eventId)) {
        this.footerMessages$ = this.eventData.getListMessagesFooter(this.clientId, this.eventId)
          .do(() => this.footerView = false)
          .do(list => this.utilities.consoleDecorator('Messages footer', list, 'red'))
          .do(() => setTimeout(() => this.footerView = true, 2000))
      } else {
        this.footerMessages$ = this.msgData.getClientFooterMessageActive()
          .do(() => this.footerView = false)
          .do(list => this.utilities.consoleDecorator('Messages footer', list, 'red'))
          .do(() => setTimeout(() => this.footerView = true, 2000))
      }
    }
  }

  findCart() {
    if (this.user) {
      this.shoppingCart$ = this.paymentData.getUserShoppingCart(this.user.info.id);
    }
  }

  async go(module) {
    switch (module) {
      case 'networking':
        if (this.user) {
          if (this.user.info.isNetworking) {
            return this.navCtrl.push('networking-contact', { eventId: this.eventId });
          }
        }
        this.toastCtrl.create({
          message: await this.translatePipe.transform('You must complete your profile and activate the networking before continuing'),
          duration: 3000,
          position: 'top'
        }).present();
        return this.navCtrl.push('UserEditPage', { eventId: this.eventId });

      case 'questions':
        return this.navCtrl.push('QuestionPage', { eventId: this.eventId }, { animate: true, direction: 'forward' });

      case 'catalog':
        // return this.navCtrl.push('categoriesProduct', { eventId: this.eventId }, { animate: true, direction: 'forward' });
        return this.navCtrl.push('catalog-list', { eventId: this.eventId, filter: 'category', ref: 'all' }, { animate: true, direction: 'forward' });

      case 'opinometer':
        return this.navCtrl.push('PollPage', { eventId: this.eventId }, { animate: true, direction: 'forward' });

      case 'shared':
        return this.utilities.shareURL();

      // case 'home':
      //   return this.navCtrl.setRoot('room', {}, { animate: true, direction: 'forward' });

      default:
        this.utilities.consoleDecorator('Module selected', module);
    }
  }

  footerCallback(msg) {
    let target = "_self";
    if (has(msg, "is_external")) {
      if (msg.is_external) {
        target = "_blank"
      }
    }

    if (msg.callback !== '') {
      window.open(msg.callback, target);
    }
  }

  public itsEvent() {
    return this.utilities.validateEventIdParam(this.eventId);
  }

  public canShowPollButton(type: 'client' | 'event') {
    switch (type) {
      case 'client':
        if (has(this.pollPage, 'activePollInformation')) {
          return this.pollPage.activePollInformation !== undefined;
        } else {
          return false;
        }
      case 'event':
        if (has(this.eventPollPage, 'activePollInformation')) {
          return this.eventPollPage.activePollInformation !== undefined;
        } else {
          return false;
        }
    }
  }

  public canShowVotingButton(type: 'client' | 'event') {
    switch (type) {
      case 'client':
        return false;
      case 'event':
        if (has(this.eventVotingPage, 'activeVotingInformation')) {
          return this.eventVotingPage.activeVotingInformation !== undefined;
        } else {
          return false;
        }
    }
  }

  public openPoll(type: 'client' | 'event') {
    switch (type) {
      case 'client':
        this.pollPage.openPollModal();
        break;
      case 'event':
        this.eventPollPage.openPollModal();
    }
  }

  public openVoting(type: 'client' | 'event') {
    switch (type) {
      case 'client':
        break;
      case 'event':
        this.eventVotingPage.openVotingModal();
    }
  }

  public async selectPollOrVoting(type: 'client' | 'event') {
    const actionSheet = this.actionSheetCtrl.create({
      title: await this.translatePipe.transform('Participate on'),
    });

    if (this.modules.voting && this.canShowVotingButton(type)) {
      actionSheet.addButton({
        text: await this.translatePipe.transform('Poll'),
        handler: () => this.openVoting(type)
      });
    }

    if (this.modules.opinometer && this.canShowPollButton(type)) {
      actionSheet.addButton({
        text: await this.translatePipe.transform('Survey'),
        handler: () => this.openPoll(type)
      });
    }

    actionSheet.addButton({
      text: await this.translatePipe.transform('Cancel'),
      role: 'cancel'
    });

    actionSheet.present();
  }

  public canShowShareAPI() {
    return has(navigator, 'share');
  }

  // public shareAPI(){
  //   if ((<any>window).navigator.share) {
  //     (<any>window).navigator.share({
  //         title: 'Rebus Event App ',
  //         text: 'Check out Rebus App — it rocks!',
  //         url: `https://rebus-frontend-v4.firebaseapp.com/`,
  //     })
  //       .catch((error) => console.log('Error sharing', error));
  //       this.gamification.applyPoints(ENV.client,this.user.info.id,'shared');
  //   }
  // }

  private shareStandarOption(type: 'whatsapp' | 'facebook' | 'twitter' | 'linkedin') {
    this.utilities.consoleDecorator('Current url user', window.location.href);

    const url = window.location.toString();

    switch (type) {
      case 'linkedin':
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${url}&utm_source=LinkedIn&source=Rebus+Technology`, "_blank");
        break;
      case 'whatsapp':
        window.open(`https://api.whatsapp.com/send?text=Interact%20with%20users%2C%20%0A${url}`, "_blank");
        break;
      case 'facebook':
        (<any>window).FB.ui({
          method: 'share',
          href: url
        }, function (response) { });
        break;
      case 'twitter':
        window.open(`http://twitter.com/share?text=Interact+with+users&url=${url}&via=Rebus`, "_blank");
        break;
    }
    this.utilities.consoleDecorator('Apply points', this.user);
    this.gamification.applyPoints(ENV.client, this.user.info.id, 'shared');
    if (this.userPatnerId) this.gamification.applyPointsPartner(ENV.client, this.userPatnerId, this.user.info.id, 'shared');
  }

  public shareOptions() {

    let navigationShare: any;
    navigationShare = window.navigator;

    if (navigationShare && navigationShare.share) {
      if (this.textDetailModule) {
        navigationShare.share({
          title: this.titleShare,
          text: `${this.textShare}: ${this.textDetailModule}`,
          url: window.location.href
        }).catch((error) => this.utilities.consoleErrorAll('Error sharing:', error));
      } else {
        navigationShare.share({
          title: this.titleShare,
          text: this.textShare,
          url: window.location.href
        }).catch((error) => this.utilities.consoleErrorAll('Error sharing:', error));
      }
    } else {
      this.actionCtrl.create({
        title: 'Select an option to share',
        buttons: [{
          text: 'Whatsapp',
          handler: () => {
            this.shareStandarOption('whatsapp');
            return true;
          }
        }, {
          text: 'Linkedin',
          handler: () => {
            this.shareStandarOption('linkedin');
            return true;
          }
        }, {
          text: 'Facebook',
          handler: () => {
            this.shareStandarOption('facebook');
            return true;
          }
        }, {
          text: 'Twitter',
          handler: () => {
            this.shareStandarOption('twitter');
            return true;
          }
        }]
      }).present();
    }
  }

  public shoppinCart() {
    this.navCtrl.push('ShoppingCart', { eventId: this.eventId });
  }

  ngOnDestroy() {
    if (this.clientSubscribe) this.clientSubscribe.unsubscribe();
    if (this.userSubscribe) this.userSubscribe.unsubscribe();
    if (this.eventSubscribe) this.eventSubscribe.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/components/interactivity-options/interactivity-options.ts